import naja from 'naja';
import Gallery from '../classes/gallery';

export default function initGallery(paramContainer) {
  const container = paramContainer || document.body;

  container.querySelectorAll('[data-aui-gallery]')?.forEach((galleryElement) => {
    Gallery.init(galleryElement);
  });

  container.querySelectorAll('[data-aui-lookbook]')?.forEach((lookbookElement) => {
    Gallery.initLookbook(lookbookElement);
  });
}

naja.addEventListener('init', () => {
  initGallery(document.body);
});

naja.snippetHandler.addEventListener('afterUpdate', (event) => {
  initGallery(event.detail.snippet);
});